import { computed, ref } from "vue";

const state = ref({
    huonekortit: [] as  {id: number, nimi: string}[],
})

export function useComSideMenu() {
    const add = (val: number, nimi?: string) => {
        if (!state.value.huonekortit.find((h) => h.id === val)) {
            state.value.huonekortit.push({ id: val, nimi: nimi ?? "" })
        }
    }
    const remove = (val: number) => {
        const f = state.value.huonekortit.findIndex((h) => h.id === val)

        if (f !== -1) {
            state.value.huonekortit.splice(f, 1)
        }
    }
    const clear = () => {
        state.value.huonekortit = []
    }
    const huonekortit = computed(() => state.value.huonekortit)

    return {
        huonekortit,
        add,
        remove,
        clear
    }
}